import React from 'react';

import FileComponent from 'components/organisms/file2';
import { WO_SUPPORTED_FILE_FORMATS } from 'components/organisms/file2/config';
import { Accept } from 'components/organisms/file2/types';
import { useId } from 'hooks/useId';

import { CommonFieldWrapper } from '../CommonFieldWrapper';
import { SUPPORTED_FILE_FORMAT_DESC } from '../config';
import { SharedProps } from '../typing';
import useFileInputLogic from './useFileInputLogic';

export default function FileInput<TForm = Record<string, any>>({
  fieldName,
  label,
  required,
  disabled: localDisabled,
  maxFileSizeMB,
  accept,
  description,
}: SharedProps<TForm> & {
  maxFileSizeMB?: number;
  accept?: Accept;
  description?: string;
}) {
  const {
    error,
    disabled,
    handleUpdateDocumentOnViewer,
    value,
    setValue,
    fileDisplayStr,
    isUpdatingFieldValuePending,
  } = useFileInputLogic<TForm>(fieldName, localDisabled, maxFileSizeMB);
  const id = useId();

  return (
    <CommonFieldWrapper
      id={id}
      label={label}
      required={required}
      fieldName={fieldName}
      errorMessage={error?.message}
      description={
        disabled ? undefined : (description ?? SUPPORTED_FILE_FORMAT_DESC)
      }
    >
      <FileComponent
        id={id}
        value={value}
        accept={accept ?? WO_SUPPORTED_FILE_FORMATS}
        onChange={setValue}
        fileDisplayStr={fileDisplayStr}
        onUpdateDocumentOnViewer={handleUpdateDocumentOnViewer}
        isDisabled={disabled}
        isUpdateFieldValuePending={isUpdatingFieldValuePending}
      />
    </CommonFieldWrapper>
  );
}
